import { useRef, useState, type FormEvent } from 'react';
import { PASSWORD_MIN_LENGTH } from '@longjie/shared';
import { ApiError, request } from './api';
import { Button, Field, Modal } from './components';

export function OwnPasswordModal({ onClose, onSaved }: { onClose: () => void; onSaved: () => void; customerAccount?: boolean }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const savingRef = useRef(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (savingRef.current) return;
    setError('');
    if (!currentPassword) {
      setError('请输入当前密码');
      return;
    }
    if (newPassword.length < PASSWORD_MIN_LENGTH || newPassword.length > 200) {
      setError(`新密码需为 ${PASSWORD_MIN_LENGTH} 至 200 位`);
      return;
    }
    if (newPassword.toLowerCase() !== confirmation.toLowerCase()) {
      setError('两次输入的新密码不一致');
      return;
    }
    savingRef.current = true;
    setLoading(true);
    try {
      await request('/api/v1/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      onSaved();
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : '密码修改失败');
    } finally {
      savingRef.current = false;
      setLoading(false);
    }
  }

  return (
    <Modal
      title="修改我的密码"
      description={`请输入当前密码验证身份。新密码至少 ${PASSWORD_MIN_LENGTH} 位，可使用字母、数字或符号，不要求组合。不区分字母大小写，数字和符号原样匹配。`}
      onClose={() => { if (!savingRef.current) onClose(); }}
      footer={<>
        <Button variant="secondary" onClick={onClose} disabled={loading}>取消</Button>
        <Button form="own-password-form" type="submit" loading={loading}>保存新密码</Button>
      </>}
    >
      <form id="own-password-form" className="form-grid" onSubmit={submit}>
        {error && <div className="inline-error form-grid__full" role="alert">{error}</div>}
        <p className="field__hint form-grid__full">管理员可协助查看本系统密码，请使用专用密码。</p>
        <div className="form-grid__full">
          <Field label="当前密码">
            <input type="password" autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} maxLength={200} disabled={loading} required autoFocus />
          </Field>
        </div>
        <div className="form-grid__full">
          <Field label="新密码">
            <input type="password" autoComplete="new-password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} minLength={PASSWORD_MIN_LENGTH} maxLength={200} disabled={loading} required />
          </Field>
        </div>
        <div className="form-grid__full">
          <Field label="确认新密码">
            <input type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} minLength={PASSWORD_MIN_LENGTH} maxLength={200} disabled={loading} required />
          </Field>
        </div>
      </form>
    </Modal>
  );
}
